import Axios from '../config/axios';
import { atom } from 'recoil';

export const availableUsersState = atom({
    key: 'availableUsersState',
    default: []
});

export const queueUsersState = atom({
    key: 'queueUsersState',
    default: []
});

export const workflowItemsState = atom({
    key: 'workflowItemsState',
    default: []
});

export function getAdminManageItems() {
    return Axios.get('/api/GetAdminManageItems').then(response => response.data).catch(error => error);
/*    return Axios.get('/api/GetAdminManageItems', { params: { epicorCompany }}).then(response => response.data).catch(error => error);*/
}

export function insertQueueUsers(postdata) {
    return Axios.post('/api/InsertQueueUsers', postdata).then(response => response.data).catch(error => error);
}

export function removeQueueUsers(postdata) {
    return Axios.post('/api/RemoveQueueUsers', postdata).then(response => response.data).catch(error => error);
}

export function insertWorkflowItem(postdata) {
    return Axios.post('/api/InsertWorkflowItem', postdata).then(response => response.data).catch(error => error);
}

export function deleteWorkflowItem(postdata) {
    return Axios.post('/api/DeleteWorkflowItem', postdata).then(response => response.data).catch(error => error);
}

export function updateWorkflowItemRecipients(postdata) {
    return Axios.post('/api/UpdateWorkflowItemRecipients', postdata).then(response => response.data).catch(error => error);
}

//Users
export function getAllUsers() {
    return Axios.post('/api/GetAllUsers').then(response => response.data).catch(error => error);
}

export function UpdateUser(postdata) {
    return Axios.post('/api/UpdateUser', postdata).then(response => response.data).catch(error => error);
}

export function AddNewUser(postdata) {
    console.log(postdata);
    return Axios.post('/api/AddNewUser', postdata).then(response => response.data).catch(error => error);
}

export function DeleteUser(postdata) {
    return Axios.post('/api/DeleteUser', postdata).then(response => response.data).catch(error => error);
}